import { gql } from '@apollo/client';

const QUERY = gql`
  query FilteredEmails($organizationId: ID!, $pageNumber: Int, $pageSize: Int) {
    filteredEmails(filter: {
      organizationId: $organizationId,
      pageNumber: $pageNumber,
      pageSize: $pageSize
    }) {
      metadata {
        totalEntries
      }
      data {
        id
        body
        subject
        isDraft
        senderName
        sentAt
        emailRecipients {
          divisionId
          divisionName
          seasonId
          seasonName
          programId
          programName
        }
      }
    }
  }
`;

export default QUERY
